export default "__VITE_ASSET__821a2879__"